import { jsx as _jsx } from "react/jsx-runtime";
import { AccountMenuPopover } from '../../components/account/account-menu/AccountMenuPopover';
import { useOAuth } from '../../hooks/useOAuth';
export const AccountMenuContainer = ({ items, anchorEl, onClose }) => {
    const { logout } = useOAuth();
    const handleLogout = () => {
        logout();
    };
    return _jsx(AccountMenuPopover, { items: items, anchorEl: anchorEl, onClose: onClose, logout: handleLogout });
};
